const configsCumulative = ["Head", "bodyAttributes", "htmlAttributes"];
function includes(values, x) {
  return values.includes(x);
}
export {
  configsCumulative as c,
  includes as i
};
//# sourceMappingURL=includes-DAjktrRi.js.map
